<template>
  <div>
    <flow-step-base
      :name="flowStepTitle"
      :guid="step.guid"
      :imgPath="img"
      :description="flowStepLabel"
      @disable="$emit('update', { enabled: false })"
      @rework="$emit('rework')"
    >
      <offer-card-new
        :choice="step"
        @update="(update) => offerUpdate(step.guid, update)"
        @create="(offerType) => createOffer(step.guid, offerType)"
        @delete="deleteOffer(step.guid)"
      ></offer-card-new>
    </flow-step-base>
  </div>
</template>

<script>
import FlowStepBase from '@/components/FlowSteps/FlowStepBase.vue';
import OfferCardNew from '@/components/Builder/OfferCardNew.vue';
import { createBaseOffer, STEP_TYPE } from '@/store/shared';
import { SET_BLUEPRINT_STEP } from '@/store/mutation-types';
import { BLUEPRINT_SCHEDULE_SAVE } from '@/store/action-types';
import { mapGetters } from 'vuex';
import img from '@/assets/img/icon-initialoffer.svg';

export default {
  name: 'FlowStepOffer',
  props: {
    step: {
      type: Object,
      required: true,
    },
    isFinalOffer: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FlowStepBase,
    OfferCardNew,
  },
  data() {
    return {
      img,
    };
  },
  computed: {
    blueprint() {
      return this.$store.getters.currentBlueprint;
    },
    stepMap() {
      return this.$store.getters.blueprintStepMap;
    },
    surveyStep() {
      return this.stepMap[STEP_TYPE.OFFER];
    },
    flowStepTitle() {
      return this.isFinalOffer ? 'Final Offer' : 'Initial Offer';
    },
    flowStepLabel() {
      return this.isFinalOffer ? 'Present customers with a final offer.' : 'Present customers with an initial offer.';
    },
  },
  methods: {
    scheduleSave() {
      this.$store.dispatch(BLUEPRINT_SCHEDULE_SAVE, { id: this.blueprint._id });
    },
    stepUpdate() {
      this.$store.commit(SET_BLUEPRINT_STEP, this.step);
      this.scheduleSave();
    },
    createOffer(stepGuid, offerType) {
      const newOffer = createBaseOffer(offerType);
      this.step.offer = newOffer;
      this.stepUpdate();
    },
    deleteOffer(stepGuid) {
      delete this.step.offer;
      this.stepUpdate();
    },
    offerUpdate(stepGuid, update) {
      this.step.offer = {
        ...this.step.offer,
        ...update,
      };
      this.step.header = update.header ? update.header : this.step.header;
      this.step.description = update.description ? update.description : this.step.description;
      this.stepUpdate();
    },
  },
};
</script>
